/**
 *
 * LinkButton
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

import { COLORS } from '../../../../theme';

function LinkButton({ children, sx, ...props }) {
  return (
    <Button
      sx={{
        '&&&': {
          minHeight: 'unset',
          padding: 0,

          'svg path': {
            fill: COLORS.black40,
            transition: 'fill 0.25s',
          },

          '&:hover': {
            background: 'transparent',

            'svg path': {
              fill: COLORS.kinetikBlack,
            },
          },
          '&.Mui-disabled': {
            'svg path': {
              fill: COLORS.black20,
            },
          },
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}

LinkButton.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default memo(LinkButton);
